import React from 'react';

const Record = () => {
    return (
      <React.Fragment>
        <div className="btn__base r5c1">
          <div className="btn"></div>
        </div>
      </React.Fragment>
    );
  };

export default Record;